import Question from '../interfaces/question';

const minRequiredText = (): string => '*Required - Select all that apply';
const maxRequiredText = ({ max }: { max: number }): string =>
  `*Required - pick up to ${max} reasons below`;
const betweenRequiredText = ({ min, max }: { min: number; max: number }): string =>
  `*Required - Select from ${min} to ${max} answers below`;

const limitPhrase = ({ question }: { question: Question }): string | undefined => {
  const min = question.minRequired;
  const max = question.maxRequired;
  if (min && max) return betweenRequiredText({ min, max });
  if (min) return minRequiredText();
  if (max) return maxRequiredText({ max });
  return undefined;
};

export { minRequiredText, maxRequiredText, betweenRequiredText, limitPhrase };
